import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class TooLargePercentageDiscountValueError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.items.discount-value.too-large-percentage-discount');
    }
}

export class TooLargeQuotaDiscountValueError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.items.discount-value.too-large-quota-discount');
    }
}
